export enum FriendsOfTheKitchenContentTabs {
  SHOW_ALL = 'SHOW ALL'
}

export enum KitchenGalleryBrandsContentTabs {
  ALL_BRAND = 'ALL BRAND',
  ALL_SUBZERO = 'ALL SUBZERO',
  ALL_WOLF = 'ALL WOLF'
}

export enum KitchenGalleryProductsContentTabs {
  ALL_PRODUCT = 'ALL PRODUCT',
  CLASSIC_REFRIGERATION = 'Classic Refrigeration',
  DESIGNER_REFRIGERATION = 'Designer Refrigeration',
  WINE_STORAGE = 'Wine Storage',
  BUILT_IN_OVEN = 'Built-in Oven',
  COFFEE_SYSTEM = 'Coffee System',
  DUAL_FUEL_RANGE = 'Dual Fuel Range'
}

export enum VideoGalleryContentTabs {
  ALL_VIDEO_CHANNELS = 'ALL VIDEO CHANNELS'
}

export enum ShowroomContentTabs {
  ALL = 'All'
}

export enum RecipeDropdownTabs {
  ALL_COURSES = 'COURSE',
  ALL_FOODTYPE = 'FOOD TYPE',
  ALL_PRODUCTS = 'PRODUCTS'
}
